import { getCsrfValue } from "~/common/utils/ApiHelper";
import { type WishlistEntryModel } from "~/features/wishlist/types/model";
import { resolveApiUrl } from "~/utils/url/urlResolver";

const apiUrl = resolveApiUrl("/wishlist/updateEntry");

export function sendUpdateWishlistEntry({
  wishlistId,
  oldEntry,
  updatedEntry,
}: {
  wishlistId: string;
  oldEntry: WishlistEntryModel;
  updatedEntry: WishlistEntryModel;
}) {
  // NOTE: quantity === 0 means deleting the item

  const body: any = {};

  body.id = wishlistId;
  body.productCode = oldEntry.productCode;
  if (oldEntry.productCode !== updatedEntry.productCode) {
    body.newProductCode = updatedEntry.productCode;
  }
  if (oldEntry.priceReference !== updatedEntry.priceReference) {
    body.priceReference = updatedEntry.priceReference;
  }

  body.quantity = updatedEntry.quantity;
  body.comment = updatedEntry.comment;
  body.wishlistEntryNumber = updatedEntry.wishlistEntryNumber;

  body.optionalParts = updatedEntry.optionalParts;

  return fetch(apiUrl, {
    body: JSON.stringify(body),
    method: "POST",
    cache: "no-cache",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });
}
